import { Injectable } from "@angular/core";

export interface StorageMap {
    [key: string]: any
}

@Injectable()
export class AppStorageService {
    public get = (key, asObject) => {
        if (asObject === void 0) { asObject = false; }
        var result = window.localStorage[key];
        if (result !== undefined && asObject) {
            result = JSON.parse(result);
        }
        return result;
    }


    public saveItems(items: StorageMap): void {
        Object.keys(items).forEach(key => {
            this.save(key, items[key]);
        });
    };

    public save = (key, value) => {
        var saveValue = value;
        if (value && typeof (value) === 'object') {
            saveValue = JSON.stringify(value);
        }
        window.localStorage[key] = saveValue;
    };

    public delete = (key) => {
        window.localStorage.removeItem(key);
    }
}
